import { connector, store } from "./store";

export function getConnectorValue(){
    return connector.getValue().entities.isConnected;
}

export function getPhpFolderPath(){
    let path = "php/";
    if(connector.getValue().entities.isConnected && !connector.getValue().entities.local){
        path = "../"+path;
    }
    return path;
}